// extracted by mini-css-extract-plugin
export var divider = "_17-0";
export var dividerText = "_17-1";